<template>
    <section>
        <v-row class="d-none">
            <v-col cols="9" class="my-auto">
                <h4 class="justify-center">{{ $route['meta']['title'] }}</h4>
            </v-col>
        </v-row>
        <v-row v-if="isalertshow">
            <v-col cols="12" sm="12" md="12">
                <alert v-if="isalertshow" :message="isalertmessage" />
            </v-col>
        </v-row>
        <v-card elevation="10">
            <v-card-item class="py-4 px-6" v-if="title">
                <div class="d-sm-flex align-center justify-space-between">
                    <v-card-title style="font-size: 14px">
                        {{ title ? title : null }}
                        <p v-for="(item, key) in data" :key="key">{{ item }}</p>
                    </v-card-title>
                    <!-- <template v-slot:append> -->
                    <slot name="action"></slot>
                    <!-- </template> -->
                </div>
            </v-card-item>
            <v-divider></v-divider>
            <v-card-text>
                <slot />
            </v-card-text>
        </v-card>
    </section>
</template>
<script>
export default {
    props: ['title', 'data', 'isalertshowdata', 'isalertmessage'],
    emits: ['update:isalertshowdata'],
    data() {
        return {
            items: [
                {
                    text: 'Dashboard',
                    disabled: false,
                    href: './dashboard'
                }
            ],
            istitle: true,
            isalertshow: false,
            alertTimer: null
        };
    },
    methods: {
        breadcrumb() {
            if (this.$route['meta']['title']) {
                this.items.push({
                    text: this.$route['meta']['title'],
                    disabled: true,
                    href: '#'
                });
            } else {
                this.items[0].disabled = false;
            }
        }
    },
    async created() {
        this.breadcrumb();
    },
    watch: {
        isalertshowdata(val) {
            this.isalertshow = val;
            // Restart the countdown instead of stacking timers. A banner
            // raised while an earlier one was still counting down used to
            // inherit that older timeout and disappear early.
            clearTimeout(this.alertTimer);
            if (!val) return;
            this.alertTimer = setTimeout(() => {
                this.isalertshow = false;
                // Hand the flag back to the parent. Hiding only our own copy
                // left the parent's prop stuck at true, so its next
                // `isalertmustshow = true` was not a change, this watcher
                // never fired again, and every banner after the first was
                // silent for the life of the page.
                this.$emit('update:isalertshowdata', false);
            }, 4000);
        }
    },
    beforeUnmount() {
        clearTimeout(this.alertTimer);
    },
    mounted() {}
};
</script>
